import React, { useState, useEffect,useRef, useContext, Component } from 'react';
import { useNavigate,Link } from "react-router-dom";
import TestingHeader from './TestingHeader';
import TestingFooter from './TestingFooter';
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim"; // lightweight version
import { motion, useInView, animate } from "framer-motion";
import spaceAudio from '../../assets/audio/space.mp3'; // ✅ Correct way to import audio
import scrollSound from '../../assets/audio/scroll.mp3'; // ✅ Correct way to import audio
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Thumbs, Pagination } from "swiper/modules";

 const TestingBrand = () => {

 const texts = [
  "Welcome To Hanwha Vision",
  "Leading Global Security Solutions",
  "Innovating Video Surveillance"
];

const [displayText, setDisplayText] = useState("");
const [textIndex, setTextIndex] = useState(0);
const [charIndex, setCharIndex] = useState(0);

useEffect(() => {
  const currentText = texts[textIndex];

  if (charIndex < currentText.length) {
    const timeout = setTimeout(() => {
      setDisplayText(currentText.substring(0, charIndex + 1));
      setCharIndex(charIndex + 1);
    }, 70);

    return () => clearTimeout(timeout);
  } else {
    // Wait before typing next text
    const pause = setTimeout(() => {
      setCharIndex(0);
      setTextIndex((prev) => (prev + 1) % texts.length);
    }, 1500);

    return () => clearTimeout(pause);
  }
}, [charIndex, textIndex]);



    const videoRef = useRef(null);
  const [autoPlayed, setAutoPlayed] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    // 1) Play video once automatically
    const onEnded = () => {
      setAutoPlayed(true);
      video.pause();
    };

    video.addEventListener("ended", onEnded);

    return () => {
      video.removeEventListener("ended", onEnded);
    };
  }, []);

  useEffect(() => {
    if (!autoPlayed) return; // Scroll control works only after auto-play done

    const video = videoRef.current;
    let lastScrollY = window.scrollY;

const handleScroll = () => {
  const currentScrollY = window.scrollY;
  const diff = currentScrollY - lastScrollY;

  // Slow speed
  const speed = Math.abs(diff) * 0.009;

  if (diff > 0) {
    // ⬇ Scroll Down → Reverse play
    video.currentTime = Math.max(video.currentTime - speed, 0);
  } else if (diff < 0) {
    // ⬆ Scroll Up → Forward play
    video.currentTime = Math.min(video.currentTime + speed, video.duration);
  }

  lastScrollY = currentScrollY;
};


    window.addEventListener("scroll", handleScroll);
    
    return () => window.removeEventListener("scroll", handleScroll);
  }, [autoPlayed]);



    const [hide, setHide] = useState(false);



  const bgAudioRef = useRef(null);
  const scrollAudioRef = useRef(null);
  const playedScroll = useRef(false);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    const bg = bgAudioRef.current;
    const scrollFx = scrollAudioRef.current;
    if (!bg || !scrollFx) return;

    // ✅ Background Audio setup
    bg.loop = true;
    bg.volume = 0.2;
    bg.preload = "auto";
    bg.currentTime = 0.3;

    bg.play()
      .then(() => setIsPlaying(true))
      .catch(() => {
        console.log("Autoplay blocked — click once to start background audio.");
        const startBg = () => {
          bg.play().then(() => setIsPlaying(true)).catch(() => {});
          window.removeEventListener("click", startBg);
        };
        window.addEventListener("click", startBg);
      });

    // ✅ Scroll effect
    const playScrollFx = () => {
      if (playedScroll.current) return;
      playedScroll.current = true;
      scrollFx.currentTime = 0;
      scrollFx.volume = 0.2;
      scrollFx.play().catch(() => {});
      setTimeout(() => (playedScroll.current = false), 800);
    };

    window.addEventListener("scroll", playScrollFx);
    return () => window.removeEventListener("scroll", playScrollFx);
  }, []);

  // ✅ Toggle audio manually
  const handleToggleAudio = () => {
    const bg = bgAudioRef.current;
    const scrollFx = scrollAudioRef.current;
    if (!bg || !scrollFx) return;

    if (isPlaying) {
      bg.pause();
      scrollFx.pause();
      setIsPlaying(false);
    } else {
      bg.play().then(() => setIsPlaying(true)).catch(() => {});
      // Don’t auto-play scrollFx; it’s handled on scroll
    }
  };

    const [flipped, setFlipped] = useState(null);

    const category  = [
  { id: 1, title: "Box Cameras", img: "https://hvsgmpprdstorage.blob.core.windows.net/pim/TNB-9000/thumbnails/large_10/TNB-9000_S1_En.png" },
  { id: 2, title: "Dome Cameras", img: "https://hvsgmpprdstorage.blob.core.windows.net/pim/XNV-A8084R/thumbnails/medium_03/XNV-A9084RA8084R_01_M.png" },

  // Newly added
  { id: 3, title: "Bullet Cameras", img: "https://www.hanwhavision.com/wp-content/uploads/2023/05/QNO-C8083RC9083R_KO_white_01_M-1.png" },
  { id: 4, title: "PTZ Cameras", img: "https://artemedia-internal.s3.amazonaws.com/panasonics/7290a1292015571e46853b0.png" },
  { id: 5, title: "Fisheye Cameras", img: "https://artemedia-internal.s3.amazonaws.com/panasonics/3f10095132b56a686733108.png" },
  { id: 6, title: "Multi-Sensor Cameras", img: "https://artemedia-internal.s3.amazonaws.com/panasonics/17f590504979e781a665675.png" },
   { id: 8, title: "Thermal Cameras", img: "https://hanwhavisionamerica.com/wp-content/uploads/Product-Images/TNM-C4940TD/en/TNM-C4940TDRC4942TDR_white_01_M.png" },
  { id: 9, title: "Panoramic / 360° Cameras", img: "https://www.hanwhavision.com/wp-content/uploads/2020/10/XNF-9013RV9010RV9010RVM_01_M.png" },
   
];

 const [engineReady, setEngineReady] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine); // load the minimal engine
    }).then(() => {
      setEngineReady(true);
    });
  }, []);

 
  // 👇 OUTSIDE any component
const particlesOptions = {
  background: { color: { value: "white" } },
  fpsLimit: 60,
  interactivity: {
    events: {
      onHover: { enable: true, mode: "repulse" },
      onClick: { enable: true, mode: "push" },
    },
    modes: {
      repulse: { distance: 100, duration: 0.4 },
      push: { quantity: 3 },
    },
  },
  particles: {
    color: { value: "#f6ff00ff" },
    links: {
      // color: "#2d3058ff",
          color: "#ffffffff",
      distance: 120,
      enable: true,
      // opacity: 0.3,
      opacity: 1,
       width: 1,
    },
    move: {
      enable: true,
      speed: 1,
      outModes: { default: "bounce" },
    },
    number: { value: 150, density: { enable: true, area: 100 } },
    opacity: { value: 0.3 },
    shape: { type: "circle" },
    size: { value: { min: 1, max: 3 } },
  },
  detectRetina: true,
};


  function Counter({ to = 0, duration = 1.2, suffix = "", decimals = 0 }) {
  const ref = React.useRef(null);
  const inView = useInView(ref, { once: true, margin: "0px 0px -20% 0px" });
  const [value, setValue] = React.useState(0);

  React.useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration,
      ease: "easeOut",
      onUpdate: (v) => {
        const factor = Math.pow(10, decimals);
        setValue(Math.round(v * factor) / factor);
      },
    });
    return () => controls.stop();
  }, [inView, to, duration, decimals]);

  return (
    <span ref={ref}>
      {value.toLocaleString(undefined, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      })}
      {suffix}
    </span>
  );
}


const testimonialDate =[
  {
    id: 1,
    name: "Rahul Sharma",
    message:
      "Working with Altima has been an incredibly smooth and rewarding experience. Their team understood our office security requirements perfectly and suggested solutions that were both practical and advanced. The installation process was handled professionally, with clear communication at every stage. What impressed me most was the way they explained each feature and ensured we were fully comfortable using the system. Ever since the upgrade, our staff feels safer and our overall monitoring is far more efficient. I would highly recommend Altima to anyone looking for reliable and intelligent security systems.",
  },

  {
    id: 2,
    name: "Neha Verma",
    message:
      "Altima has truly exceeded our expectations. Their perimeter security solution has made a huge difference to our residential property. From the very first consultation, the team was transparent, knowledgeable, and extremely patient in answering all our questions. The quality of their equipment is top-notch and the response time has been exceptional. We’ve already noticed a major improvement in safety and awareness around our premises. Their after-sales support is just as impressive—always available, polite, and very helpful. I am extremely satisfied and confidently recommend Altima to others.",
  },

  {
    id: 3,
    name: "Amit Gupta",
    message:
      "The level of professionalism and expertise that Altima brought to our home automation project was outstanding. They handled everything from planning to installation with great attention to detail. The automation system is seamless, intuitive, and has genuinely improved our everyday comfort. Whether it’s lighting, security, or AV integration, everything works perfectly in sync. What truly sets Altima apart is the way they prioritize customer convenience—they ensure everything is simple to use and customized to your lifestyle. It was one of the best investments we made for our home.",
  },

  {
    id: 4,
    name: "Priya Singh",
    message:
      "We hired Altima for a complete AV transformation of our conference room, and the outcome was beyond impressive. The sound clarity, display quality, and overall design have elevated the professional experience for our entire team. Their engineers are highly skilled and take the time to understand the exact requirements before recommending solutions. The project was completed on time, and the training provided afterward made everything very easy to operate. Even guests who visit our office frequently compliment the setup. Altima stands out for its exceptional quality, service, and long-term reliability.",
  }
];

  const [activeIndex, setActiveIndex] = useState(0); // first auto active

const IndustryData = [
  {
    id: 1,
    image:
      "https://honeywell.scene7.com/is/image/honeywell/airport-green-featured-2880x1440-1:2-1-article",
    title: "Airports",
    icon: "ri-building-2-line"
  },
  {
    id: 2,
    image:
      "https://honeywell.scene7.com/is/image/honeywell/industries-commercial-buildings-2880x1440:2-1-article",
    title: "Commercial Buildings",
    icon: "ri-community-line"
  },
  {
    id: 3,
    image:
      "https://honeywell.scene7.com/is/image/honeywell/HW-HD-DataCenterWebpageHeader-21jan2022:2-1-article",
    title: "Data Centers",
    icon: "ri-database-2-line"
  },
  {
    id: 4,
    image:
      "https://honeywell.scene7.com/is/image/honeywell/industries-education-2880x1440:2-1-article",
    title: "Education",
    icon: "ri-book-open-line"
  },
  {
    id: 5,
    image:
      "https://honeywell.scene7.com/is/image/honeywell/healthcare-head:2-1-article",
    title: "Healthcare",
    icon: "ri-stethoscope-line"
  }
];


const PARTNER_BRANDS = [
  { id: 1, name: "Hanwha", logo: "https://cdn.worldvectorlogo.com/logos/hanwha-4.svg" },
  { id: 2, name: "Tyco American Dynamics", logo: "https://www.americandynamics.net/Content/Images/Header/Logo.png" },
  { id: 3, name: "Panasonic", logo: "https://www.panasonic.com/content/dam/panasonic/common/plogo-horizontal.svg" },
  { id: 4, name: "Honeywell", logo: "https://www.honeywell.com/content/dam/honeywellbt/en/images/logos/honeywell-logo.svg" },
  { id: 5, name: "Honeywell", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ad/Hikvision_logo.svg/2560px-Hikvision_logo.svg.png" },
  { id: 6, name: "Remote Monitoring", logo: "https://www.maritimenetwork.dk/wp-content/themes/yootheme/cache/f6/Everllence-red-f6f3c52b.png" },
];

const FAQ_DATA = [
  {
    id: 1,
    question: "What kind of solutions does Altima provide?",
    answer:
      "We provide end-to-end Security, AV and Home Automation solutions including perimeter security, CCTV surveillance, access control, fire systems, auditorium AV, commercial cinema and fully integrated smart home experiences."
  },
  {
    id: 2,
    question: "Do you handle both design and installation?",
    answer:
      "Yes. Our team handles complete solution design, product selection, wiring layouts, installation, configuration and final handover. We also train your staff or family members to operate the system with ease."
  },
  {
    id: 3,
    question: "Can the systems be integrated with existing infrastructure?",
    answer:
      "In most cases, yes. We assess your current infrastructure and suggest the best way to integrate new systems with existing cabling, devices and networks to avoid unnecessary replacement costs."
  },
  {
    id: 4,
    question: "Do you provide post-installation support and maintenance?",
    answer:
      "Absolutely. We offer AMC and on-call support options. Our engineers are available for health checks, firmware upgrades, troubleshooting and future enhancements as your needs evolve."
  },
  {
    id: 5,
    question: "Do you work on residential, commercial and institutional projects?",
    answer:
      "Yes. We work with luxury homes, offices, schools, colleges, hotels, hospitals, auditoriums and industrial facilities—designing custom solutions based on the use-case and budget."
  }
];


const AWARDS = [
  {
    id: 1,
    title: "ISO 9001:2015 Certified",
    image: "/assets/img/award.png",
  },
  {
    id: 2,
    title: "Best Automation Integrator Award 2023",
    image: "/assets/img/award.png",
  },
  {
    id: 3,
    title: "Authorized Partner Certification",
    image: "/assets/img/award.png",
  },
  {
    id: 4,
    title: "Industry Excellence Badge",
    image: "/assets/img/award.png",
  },
  
];


 
  const blogData = [
  {
    id: 1,
    image: "/assets/img/home-automation.webp",
    date: "Jan 20, 2025",
    title: "How To Trust Your Intuition When You’re Making A Decision",
    author: "Altima Global",
    link: "#"
  },
  {
    id: 2,
    image: "/assets/img/home-automation.webp",
    date: "Feb 15, 2025",
    title: "The Science of Happiness: 10 Ways to Boost Your Mood",
    author: "Altima Global",
    link: "#"
  },
  {
    id: 3,
    image: "/assets/img/home-automation.webp",
    date: "Mar 5, 2025",
    title: "Mastering Time Management for Busy People",
    author: "Altima Global",
    link: "#"
  }
];

 
 const FEATURED_PRODUCTS = [
  {
    id: 1,
    title: "Video Surveillance Systems (CCTV)",
    category: "Security",
    image: "/assets/img/home-automation.webp",
    description:
      "Hanwha • Tyco American Dynamics • Panasonic • Honeywell • ANPR Cam • Remote Monitoring – Milestone & Genetec",
  },
  {
    id: 2,
    title: "Fire Safety & Alarm Systems",
    category: "Fire & Life Safety",
    image: "/assets/img/av-solution.webp",
    description:
      "Fire Alarm System • Honeywell Fire • Simplex by Johnson Control • Verbena • Bosch Fire Alarm • PA Systems • Linear Heat Sensing for Cables",
  },
  {
    id: 3,
    title: "Home Automation Solutions",
    category: "Smart Living",
    image: "/assets/img/home-automation.webp",
    description:
      "Smart Lighting • Scene-Based Controls • Motion Sensors • App & Voice Automation • Smart Thermostats • Curtain & Blinds Automation • Wireless Networking",
  },
  {
    id: 4,
    title: "Access Control & Attendance Systems",
    category: "Access Management",
    image: "/assets/img/av-solution.webp",
    description:
      "Biometric Systems • Face Access • Iris Access • Suprema • Idemia Morpho • Time Attendance Software • Integrated Access Solutions",
  },
];



    return (
        <>
      <audio ref={bgAudioRef} src={spaceAudio} preload="auto" />
    
      {/* 🔊 short scroll sound */}
      <audio ref={scrollAudioRef} src={scrollSound} preload="auto" />

            <TestingHeader />

<div className=' position-relative'>

{hide &&
<div className="hero-section py-4 position-relative overflow-hidden bg-white"  >
   {/* Particle Background */}
       
<div className="container py-4">
  <div className="row">
    <div className="col-md-6 z-1">

<div className="content-box section-headings">
  <motion.div className="subheading text-15 subheading-bg bg-white"  
   initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5, delay: 0 }} >
    <svg
      className="icon icon-14"
      xmlns="http://www.w3.org/2000/svg"
      width={14}
      height={14}
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clipPath="url(#clip0_9088_414319)">
        <path
          d="M8.71401 5.28599C11.7514 5.4205 14 5.9412 14 7C14 8.0588 11.7514 8.5795 8.71401 8.71401C8.5795 11.7514 8.0588 14 7 14C5.9412 14 5.4205 11.7514 5.28599 8.71401C2.2486 8.5795 -1.33117e-07 8.0588 0 7C4.62818e-08 5.94119 2.2486 5.4205 5.28599 5.28599C5.4205 2.2486 5.9412 0 7 0C8.0588 0 8.5795 2.2486 8.71401 5.28599Z"
          fill="CurrentColor"
        />
      </g>
      <defs>
        <clipPath>
          <rect width={14} height={14} fill="CurrentColor" />
        </clipPath>
      </defs>
    </svg>
   <span >
 welcome to ALTIMA 
  </span>
  
   
    <svg
      className="icon icon-14"
      xmlns="http://www.w3.org/2000/svg"
      width={14}
      height={14}
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clipPath="url(#clip0_9088_4143)z">
        <path
          d="M8.71401 5.28599C11.7514 5.4205 14 5.9412 14 7C14 8.0588 11.7514 8.5795 8.71401 8.71401C8.5795 11.7514 8.0588 14 7 14C5.9412 14 5.4205 11.7514 5.28599 8.71401C2.2486 8.5795 -1.33117e-07 8.0588 0 7C4.62818e-08 5.94119 2.2486 5.4205 5.28599 5.28599C5.4205 2.2486 5.9412 0 7 0C8.0588 0 8.5795 2.2486 8.71401 5.28599Z"
          fill="CurrentColor"
        />
      </g>
      <defs>
        <clipPath>
          <rect width={14} height={14} fill="CurrentColor" />
        </clipPath>
      </defs>
    </svg>
  </motion.div>

  <motion.h2
   initial={{ opacity: 0, x: -50 }}
    whileInView={{ opacity: 1, x: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5, delay: 0.2 }}
     className="heading text-70 fw-600">  
 Transform your home. Experience smart living.</motion.h2>
  <motion.div className="text text-18"   
   initial={{ opacity: 0, x: -50 }}
    whileInView={{ opacity: 1, x: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5 }}  >
    Transform your business with expert consultancy services our team of
    seasoned consultants unparalleled. Transform your business.
  </motion.div>

  


  <div className="buttons">
    <motion.div
       className="button button--secondary border"
      aria-label="hero button"
         initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
      transition={{ duration: 0.5, delay: 0.5 }}
    >
      Free Consultation
      <span className="svg-wrapper">
        <svg
          className="icon-20"
          width={20}
          height={20}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.3365 7.84518L6.16435 15.0173L4.98584 13.8388L12.158 6.66667H5.83652V5H15.0032V14.1667H13.3365V7.84518Z"
            fill="currentColor"
          />
        </svg>
      </span>
    </motion.div>
  </div>
</div>

    </div>
    <div className="col-md-6 ms-auto">
      <motion.div   initial={{ opacity: 0, y: -50 , scale: 0.5}}
    whileInView={{ opacity: 1,y: 0 , scale: 1}}
    viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.2 }} // add delay here
 className="mymodel-hero position-relative">

        <motion.div className='tvbox screen-box-container'   
         initial={{ opacity: 0, y: -50 }}
    whileInView={{ opacity: 1,y: 0 }}
    viewport={{ once: true }}
     transition={{ duration: 0.5, delay: 0.5 }} // add delay here
  >
          <div className="screen-box position-relative">
 
          <h4 className='z-1 position-relative fw-bold'> Smart TV <br/> 
       <svg
  fill="#000000"
  width="30px"
  height="30px"
  viewBox="0 0 32 32"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  className="mt-2"
>
  <path d="M16 0c-8.836 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 30.032c-7.72 0-14-6.312-14-14.032s6.28-14 14-14 14 6.28 14 14-6.28 14.032-14 14.032zM23 15h-6v-6c0-0.552-0.448-1-1-1s-1 0.448-1 1v6h-6c-0.552 0-1 0.448-1 1s0.448 1 1 1h6v6c0 0.552 0.448 1 1 1s1-0.448 1-1v-6h6c0.552 0 1-0.448 1-1s-0.448-1-1-1z" />
</svg>


 </h4>
          </div>

     <img src="/assets/img/arrow.png" className="arrow" />

        </motion.div>

          <motion.div className='speakerbox right-side screen-box-container'   
         initial={{ opacity: 0, y: -50 }}
    whileInView={{ opacity: 1,y: 0 }}
    viewport={{ once: true }}
     transition={{ duration: 0.5, delay:0.8 }} // add delay here
  >
          <div className="screen-box position-relative">
 
          <h4 className='z-1 position-relative fw-bold'> Speaker <br/> 
       <svg
  fill="#000000"
  width="30px"
  height="30px"
  viewBox="0 0 32 32"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  className="mt-2"
>
  <path d="M16 0c-8.836 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 30.032c-7.72 0-14-6.312-14-14.032s6.28-14 14-14 14 6.28 14 14-6.28 14.032-14 14.032zM23 15h-6v-6c0-0.552-0.448-1-1-1s-1 0.448-1 1v6h-6c-0.552 0-1 0.448-1 1s0.448 1 1 1h6v6c0 0.552 0.448 1 1 1s1-0.448 1-1v-6h6c0.552 0 1-0.448 1-1s-0.448-1-1-1z" />
</svg>


 </h4>
          </div>

     <img src="/assets/img/arrow.png" className="arrow" />

        </motion.div>


          <motion.div className='curtainbox right-side screen-box-container'   
         initial={{ opacity: 0, y: -50 }}
    whileInView={{ opacity: 1,y: 0 }}
    viewport={{ once: true }}
     transition={{ duration: 0.5, delay:1 }} // add delay here
  >
          <div className="screen-box position-relative">
 
          <h4 className='z-1 position-relative fw-bold'> Curtain <br/> 
       <svg
  fill="#000000"
  width="30px"
  height="30px"
  viewBox="0 0 32 32"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  className="mt-2"
>
  <path d="M16 0c-8.836 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 30.032c-7.72 0-14-6.312-14-14.032s6.28-14 14-14 14 6.28 14 14-6.28 14.032-14 14.032zM23 15h-6v-6c0-0.552-0.448-1-1-1s-1 0.448-1 1v6h-6c-0.552 0-1 0.448-1 1s0.448 1 1 1h6v6c0 0.552 0.448 1 1 1s1-0.448 1-1v-6h6c0.552 0 1-0.448 1-1s-0.448-1-1-1z" />
</svg>


 </h4>
          </div>

     <img src="/assets/img/arrow.png" className="arrow" />

        </motion.div>
        
        <img src="/assets/img/tvscreen.gif" className="tv-screen shadow" />
          <img src="/assets/img/lamp.webp" className="lamp" />
           <img src="/assets/img/speaker.gif" className="speaker" />
           <img src="/assets/img/curtain.gif" className="curtain" />
         <img src="/assets/img/3dmodel.webp" alt='3dhouse' className='w-100 hdhouse-img'/>
      </motion.div>
    </div>
  </div>
</div>



<div className='remotebox' style={{zIndex:2}}>
<div className="dashboard">
  <header>
    <div className="f fe">
      <div className="icon icon-w" />
      <div className="heading">
        <h5 className="date">1 Feb 2019</h5>
        <h2 className="title">Cloudy</h2>
      </div>
    </div>
    <div className="weather f d-flex">
      <div>
        <strong>
          26°<sup>C</sup>
        </strong>
        <p>Indoor Temp.</p>
      </div>
      <div>
        <strong>48.2%</strong>
        <p>Outdoor Humidity</p>
      </div>
      <div>
        <strong>52.99</strong>
        <p>Indoor Temp.</p>
      </div>
    </div>
  </header>
  <section>
    {/* Category */}
    <div className="category">
      <ul>
        <li>
          <a href="#!" className="active">
            Living Room
          </a>
        </li>
        <li>
          <a href="#!">Kitchen</a>
        </li>
        <li>
          <a href="#!">Dinning</a>
        </li>
        <li>
          <a href="#!">Weather</a>
        </li>
      </ul>
    </div>
    {/* Appliances */}
    <div className="appliances">
      <div className="appliance">
        <input type="checkbox" name="a" id="a" />
        <label htmlFor="a">
          <i className="l" />
          <strong>Lamp</strong>
          <span data-o="opened" data-c="closed" />
          <small />
        </label>
      </div>
      <div className="appliance">
        <input type="checkbox" name="a" id="b" />
        <label htmlFor="b">
          <i className="r" />
          <strong>Router</strong>
          <span data-o="opened" data-c="closed" />
          <small />
        </label>
      </div>
      <div className="appliance">
        <input type="checkbox" name="a" id="c" />
        <label htmlFor="c">
          <i className="a" />
          <strong>Air</strong>
          <span data-o="opened" data-c="closed" />
          <small />
        </label>
      </div>
      <div className="appliance">
        <input type="checkbox" name="a" id="d" />
        <label htmlFor="d">
          <i className="f" />
          <strong>Fridge</strong>
          <span data-o="opened" data-c="closed" />
          <small />
        </label>
      </div>
      <div className="m-player">
         <div className="player">
          <div className="disc" />
          <div className="artist">
            <p>Background Audio</p>
            <small>Tool</small>
          </div>
          <div className="controls" onClick={handleToggleAudio}>
            <input type="checkbox" name="a" id="p"  checked={isPlaying} readOnly />
            <label htmlFor="p">
              <div className="control" />
            </label>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
</div>


</div>
   }

{hide &&
<div className="hero-section py-4 position-relative overflow-hidden bg-white" style={{background:'#f7fdff'}}>

      {engineReady && (
          <Particles
            id="tsparticles"
            options={particlesOptions}
            className="position-absolute top-0 start-0 w-100 h-100"
          />
        )}

  <div className="position-relative py-4">
    <div className='container py-4'>
      <div className='row'>
        <div className="col-md-5">

<div className="content-box section-headings">
  <motion.div className="subheading text-15 text-white subheading-bg border-white"  
   initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5, delay: 0 }} >
    <svg
      className="icon icon-14"
      xmlns="http://www.w3.org/2000/svg"
      width={14}
      height={14}
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clipPath="url(#clip0_9088_414319)">
        <path
          d="M8.71401 5.28599C11.7514 5.4205 14 5.9412 14 7C14 8.0588 11.7514 8.5795 8.71401 8.71401C8.5795 11.7514 8.0588 14 7 14C5.9412 14 5.4205 11.7514 5.28599 8.71401C2.2486 8.5795 -1.33117e-07 8.0588 0 7C4.62818e-08 5.94119 2.2486 5.4205 5.28599 5.28599C5.4205 2.2486 5.9412 0 7 0C8.0588 0 8.5795 2.2486 8.71401 5.28599Z"
          fill="CurrentColor"
        />
      </g>
      <defs>
        <clipPath>
          <rect width={14} height={14} fill="CurrentColor" />
        </clipPath>
      </defs>
    </svg>
   <span >
 welcome to ALTIMA 
  </span>
  
   
    <svg
      className="icon icon-14"
      xmlns="http://www.w3.org/2000/svg"
      width={14}
      height={14}
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clipPath="url(#clip0_9088_4143)z">
        <path
          d="M8.71401 5.28599C11.7514 5.4205 14 5.9412 14 7C14 8.0588 11.7514 8.5795 8.71401 8.71401C8.5795 11.7514 8.0588 14 7 14C5.9412 14 5.4205 11.7514 5.28599 8.71401C2.2486 8.5795 -1.33117e-07 8.0588 0 7C4.62818e-08 5.94119 2.2486 5.4205 5.28599 5.28599C5.4205 2.2486 5.9412 0 7 0C8.0588 0 8.5795 2.2486 8.71401 5.28599Z"
          fill="CurrentColor"
        />
      </g>
      <defs>
        <clipPath>
          <rect width={14} height={14} fill="CurrentColor" />
        </clipPath>
      </defs>
    </svg>
  </motion.div>

  <motion.h2
   initial={{ opacity: 0, x: -50 }}
    whileInView={{ opacity: 1, x: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5, delay: 0.2 }}
     className="heading text-60 fw-600 text-dark">  
 Transform your <span className='text-Gradient'> home Experience </span>  smart living.</motion.h2>
  <motion.div className="text text-18  text-dark"   
   initial={{ opacity: 0, x: -50 }}
    whileInView={{ opacity: 1, x: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.4 }}  >
    Transform your business with expert consultancy services our team of
    seasoned consultants unparalleled. Transform your business.
  </motion.div>
  <br/>
  <motion.div className="text text-18  text-white"   
   initial={{ opacity: 0, x: -50 }}
    whileInView={{ opacity: 1, x: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5 }}  >

      <a href='#' className="hologram-btn dark">
  Learn More <i className="ri-arrow-right-up-line fs-4 fw-light"/>
 
</a>

 
  </motion.div>
</div>
        </div>

           <div className="col-md-7">
             <motion.div   
         initial={{ opacity: 0, x: 50 }}
    whileInView={{ opacity: 1,x: 0 }}
    viewport={{ once: true }}
     transition={{ duration: 0.5, delay:0.5 }}   className='3dmodel-box position-relative'>
              <div className="top-floor-bg"/>
              <div className='top-floor-box'> 
              <div className="ac-install"> 
               <img src="/assets/img/ac-on-new.webp" alt='3dhouse' className='w-100  ac-on d-none'/>   
                <img src="/assets/img/ac-off-new.webp" alt='3dhouse' className='w-100 ac-off d-block'/> 
                <div className="ac-box p-2 bg-white rounded ">
                  <div className="bg-secondary border-rounded text-white p-2 rounded d-block">
                    <h4 className='small'> OFF</h4>
                  </div>
                    <div className="bg-success border-rounded text-white p-2 rounded d-none">
                    <h4 className='small'>   23<sup>°</sup></h4>
                  </div>
                  <div className='p-2'>
                    <i className="ri-triangle-fill"/> <i className="ri-circle-fill"/>
                  </div>
                </div>
              </div>
             
               <div className="ac-border"  />

              <div className="fan-install"> 
               <img src="/assets/img/celling-fan.webp" alt='3dfan' className='w-100  celling-fan-off d-block'/>   
                <img src="/assets/img/celling-fan.gif" alt='3dfan' className='w-100 celling-fan-on d-none'/> 

                        <div className="fan-box p-2 bg-white rounded ">
                  <div className="bg-secondary border-rounded text-white p-2 rounded d-block">
                    <h4 className='small'> OFF</h4>
                  </div>
                    <div className="bg-success border-rounded text-white p-2 rounded d-none">
                    <h4 className='small'> ON</h4>
                  </div>
                  <div className='p-2'>
                    <i className="ri-triangle-fill"/> <i className="ri-circle-fill"/>
                  </div>
                </div>

              </div>

               <div className="fan-border"  />
                </div>
                <div className="ground-floor-bg"/>
                <div className="ground-floor-box">
                  
                  
                    <div className="tv-install"> 
               <img src="/assets/img/tvscreen.gif" alt='3dhouse' className='w-100  tv-on d-none'/>   
                <img src="/assets/img/tv-black.webp" alt='3dhouse' className='w-100 tv-off d-block'/> 
                <div className="ac-box custom-remode p-2 bg-white rounded ">
                  <div className="bg-secondary border-rounded text-white p-2 rounded d-block">
                    <h4 className='small'> OFF</h4>
                  </div>
                    <div className="bg-success border-rounded text-white p-2 rounded d-none">
                    <h4 className='small'>   23<sup>°</sup></h4>
                  </div>
                  <div className='p-2'>
                    <i className="ri-triangle-fill"/> <i className="ri-circle-fill"/>
                  </div>
                </div>
              </div>

                </div>

              <div className="ground-stairs-bg"/>


 <img src="/assets/img/3dhouse-new.webp" alt='3dhouse' className='w-100'/> 
  
              
            </motion.div>
        </div>

      </div>
    </div>
</div>
</div>
   }

{hide &&

<div className="hero-section py-0 position-relative overflow-hidden bg-white" >
     {engineReady && (
          <Particles
            id="tsparticles"
            options={particlesOptions}
            className="position-absolute top-0 start-0 w-100 h-100"
          />
        )}
  <img src="/assets/img/smart-bg.webp"  className='w-100'/>

</div>
      }


<div className="hero-section py-0 position-relative overflow-hidden bg-white" >
  <div className='3d-video-hero position-relative'  >
<div className='3dvideo-body position-relative z-1 ' style={{backgroundColor:'#00000078'}}>
  <div className='container d-flex align-items-center' style={{minHeight:'90vh'}} > 
 

  <div className="col text-center">
<h1 className='mb-2 text-white'> {displayText} </h1>
<p className='mb-4 text-white'>Hanwha Vision is the go-to security and surveillance solution for organizations in a wide variety of industries </p>
<a href="#" className="hologram-btn"><span> KNOW MORE</span> <i className="ri-arrow-right-up-line fs-4 fw-light"></i></a>
    </div>
 

 
    </div>

</div>
   

 <video
        
        className="w-100 object-fit-cover position-absolute h-100 top-0" 
        autoPlay
        loop
        muted
        playsInline
      >
        <source
          src="https://hanwhavisionamerica.com/wp-content/uploads/2025/10/Hanwha-Hero-Oct-2025.webm"
          type="video/mp4"
        />
      </video>

  </div>


 
</div>
 
 

 <div className="multicolumn multicolumn-page bg-white">
  <div className=' mt-50 mb-50'>

 
  <div className="container">
<div className="row">

<div className="col-md-4">
     <div className='boximgtext  position-relative rounded-4 overflow-hidden'> 
<img src="https://hanwhavisionamerica.com/wp-content/uploads/2020/12/Security_Camera_Block_Series_opt-m.jpg"/>
<h4 className='text-center'>  Search by camera series </h4>
  </div>
</div>

<div className="col-md-4">
     <div className='boximgtext  position-relative rounded-4 overflow-hidden'> 
<img src="https://hanwhavisionamerica.com/wp-content/uploads/2020/12/Security_Camera_Blocks_Form-Factor_opt-m.jpg"/>
<h4 className='text-center'>  Search by Form Factor</h4>
</div>
</div>

<div className="col-md-4">
     <div className='boximgtext  position-relative rounded-4 overflow-hidden'> 
<img src="https://hanwhavisionamerica.com/wp-content/uploads/2025/05/wisenet9-chip-548x410-1.webp"/>
<h4 className='text-center'>   Video Surveillance Technology     </h4>
</div>

</div>



</div>

    </div>
    </div>
    </div>

     
<div className="multicolumn multicolumn-page bg-white">
  <div className=' mt-50 mb-50'>

 
  <div className="container">

    <div className="multicolumn-inner">
      <div className='myheading'>

 
      <motion.h2   initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    
    transition={{ duration: 0.5, delay: 0 }}
     className=' mb-4 pb-4 '> Explore Hanwha  <span className='text-Gradient'> Categories</span></motion.h2>
          </div>



<ul className="cards">
      {category.map((service) => (
           <li key={service}>
 <a href="" className="card  bg-light-dark ">
      <img
        src={service.img}
        className="card__image drop-shadow p-4"
        alt=""
        style={{marginBottom:70}}
      />
      <div className="card__overlay">
        <div className="card__header">
          <svg className="card__arc" xmlns="http://www.w3.org/2000/svg">
            <path />
          </svg>

          <button class="button-category card__thumb position-relative"><i class="ri-arrow-right-up-long-line"></i></button>

        
          <div className="card__header-text">
            <h3 className="card__title">{service.title}</h3>
            <span className="card__status"> <i className="ri-flashlight-fill"/> trending</span>
          </div>
        </div>
        <p className="card__description">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores,
          blanditiis?
        </p>
      </div>
    </a>
           </li> ))}
 
 
</ul>
 

  </div>

   </div>
 
 
</div>

 <section className="position-relative text-white  m-0 pt-4 pb-4"   >
 
 
  <div className="container position-relative py-5"  >
    <div className="row justify-content-between  align-items-center h-100">
      <div className="col-md-7">
        <div className="myheading mb-4  ">
        <h2 className='text-dark'>Why Choose <span className="text-Gradient">  Hanwha Vision  </span></h2>
        </div>
        <p className="fs-5 mb-4 text-dark ">
          We know that AV and home automation systems are “lifestyle” items that
          should be simple and reliable to operate every time. Today’s
          constantly changing technologies make it harder and harder to operate
          even a basic home theater in a box system.  
        </p>
        
       
       
        
      <a href='#' className="hologram-btn">
   <span> KNOW MORE</span> <i className="ri-arrow-right-up-line fs-4 fw-light"/>
</a>

      </div>
      <div className="col-md-5">

         <video
        
        className="w-100 rounded-4" 
        autoPlay
        loop
        muted
        playsInline
      >
        <source
          src="https://hanwhavisionamerica.com/wp-content/uploads/2025/10/Media-PA-Hanwha-Teaser.mp4"
          type="video/mp4"
        />
      </video>

       </div>
    </div>
  </div>
</section>

 

</div>

</div>


 
 
  

 
  <section  className="multicolumn multicolumn-page bg-white pt-4 pb-4" >
    <div className="container py-5">
  {/* Heading + Arrows */}

  
<h4 className=' h6 mb-2'> Blogs </h4>
   <h2 className="text-start  mb-50"> Our <span className='text-Gradient'> Blogs </span></h2>
          
 
  {/* Blog Cards */}
  <div className="row g-4">
   

     {blogData.map((card) => (
        <div className="col-12 col-md-4" key={card.id}>
          <div
            className="card border-0 shadow-sm h-100 rounded-5"
         
          >
            <img
              src={card.image}
              className="card-img-top rounded-5"
              alt={card.title}
              style={{height:250,objectFit:'cover'}}
            />
            <div className="card-body">
              <p className="text-muted small mb-2">{card.date}</p>
              <h5 className="card-title fw-medium ">{card.title}</h5>
            </div>
            <div className="card-footer bg-white border-0 d-flex justify-content-between align-items-center pb-3 bg-transparent">
              <small className="text-muted">By {card.author}</small>
              <a href={card.link} className="text-decoration-none fw-semibold small text-dark">
                Continue Reading  <i className="ri-arrow-right-up-line"/>
              </a>
            </div>
          </div>
        </div>
      ))}

  </div>
</div>

  </section>



    <section
      className="py-5 py-md-6 bg-white"
     >
      <div className="container">
         
            <h4 className='text-dark h6 mb-2'> Trusted by Leading Global Technology Partners  </h4>

          <h2 className="text-start text-dark  mb-50 "> Our  <span className='text-Gradient'> Client  </span></h2>
      

        {/* Brand grid */}
        <div className="row g-3 g-md-4 justify-content-center">
          {PARTNER_BRANDS.map((brand) => (
            <div
              key={brand.id}
              className="col-6 col-sm-4 col-md-3 col-lg-2 d-flex"
            >
              <a
                href={brand.link}
                className="w-100 text-decoration-none"
                target="_blank"
                rel="noreferrer"
              >
                <div
                  className="h-100 d-flex align-items-center justify-content-center rounded-4 border bg-white"
                  style={{
                    background:
                      "linear-gradient(135deg, rgba(255,255,255,0.06), rgba(255,255,255,0.02))",
                    border: "1px solid rgba(255,255,255,0.07)",
                    padding: "14px 16px",
                    transition: "all 0.25s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-3px)";
                    e.currentTarget.style.boxShadow =
                      "0 10px 25px rgba(0,0,0,0.45)";
                    e.currentTarget.style.border =
                      "1px solid rgba(141, 228, 255, 0.5)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "none";
                    e.currentTarget.style.border =
                      "1px solid rgba(255,255,255,0.07)";
                  }}
                >
                  {brand.logo ? (
                    <img
                      src={brand.logo}
                      alt={brand.name}
                      className="img-fluid"
                      style={{ maxHeight: "32px", objectFit: "contain" }}
                    />
                  ) : (
                    <span
                      className="text-white fw-semibold"
                      style={{ fontSize: "14px" }}
                    >
                      {brand.name}
                    </span>
                  )}
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>


  

           
            <TestingFooter />
        </>

    );
};

export default TestingBrand